export const fileDetailsMessages = {
  deleteSuccess: 'The file was deleted successfully.',
};
